import { useSelector } from 'react-redux';
import useUserInfo from './useTtsUser';

/**
 * Hook kiểm tra trạng thái khoá ký tự của user.
 *
 * Quy tắc khoá:
 * - isCycleLocked: gói tháng (cycle) bị khoá VÀ không còn top-up credits VÀ không còn one-time credits
 * - isTopUpLocked: gói top-up bị khoá VÀ không còn one-time credits
 * - isCustomLocked: gói tuỳ chỉnh (custom) bị khoá VÀ không còn one-time credits
 * - isCreditsLocked: isCycleLocked || isTopUpLocked || isCustomLocked
 */
const useCreditsLocked = () => {
  const { remainingCharacters = 0, bonusCharacters = 0 } = useSelector(
    (state) => state.auth.user || {},
  );
  const { ttsUser } = useUserInfo();

  const { cycle, topUp, custom } = ttsUser?.studio || {};

  const { isLocked: isCycleCreditLocked } = cycle || {};
  const {
    isLocked: isTopUpCreditLocked,
    remainingCredits: remainingTopUpCredits = 0,
  } = topUp || {};
  const { isLocked: isCustomCreditLocked } = custom || {};

  const isCycleLocked =
    isCycleCreditLocked &&
    !remainingTopUpCredits &&
    !remainingCharacters &&
    !bonusCharacters;

  const isTopUpLocked =
    isTopUpCreditLocked && !remainingCharacters && !bonusCharacters;

  const isCustomLocked =
    isCustomCreditLocked && !remainingCharacters && !bonusCharacters;

  const isCreditsLocked = isCycleLocked || isTopUpLocked || isCustomLocked;

  return { isCreditsLocked, isCycleLocked, isTopUpLocked, isCustomLocked };
};

export default useCreditsLocked;
